import { createSuitMixin as i } from "../mixins/suit.js";
import e from "../util/vue-compat/Highlighter/Highlighter-vue2.vue.js";
export default {
  name: "AisSnippet",
  mixins: [i({
    name: "Snippet"
  })],
  components: {
    AisHighlighter: e
  },
  props: {
    hit: {
      type: Object,
      required: !0
    },
    attribute: {
      type: String,
      required: !0
    },
    highlightedTagName: {
      type: String,
      default: "mark"
    }
  }
};